/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsQuery
 */
export interface VccCredentialsQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof VccCredentialsQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof VccCredentialsQuery
     */
    cardProvider?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsQuery
     */
    description?: string | null;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsQuery
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsQuery
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VccCredentialsQuery
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof VccCredentialsQuery
     */
    limit?: number;
}

export function VccCredentialsQueryFromJSON(json: any): VccCredentialsQuery {
    return VccCredentialsQueryFromJSONTyped(json, false);
}

export function VccCredentialsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'cardProvider': !exists(json, 'cardProvider') ? undefined : GuidIdAndLabelFromJSON(json['cardProvider']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function VccCredentialsQueryToJSON(value?: VccCredentialsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'cardProvider': GuidIdAndLabelToJSON(value.cardProvider),
        'description': value.description,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'showDisabled': value.showDisabled,
        'offset': value.offset,
        'limit': value.limit,
    };
}


